'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange'];
module.exports = exports['default'];
//# sourceMappingURL=eventNames.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/youtube-player/dist/eventNames.js
 ** module id = 351
 ** module chunks = 0
 **/